import { shallowEqual } from 'react-redux';

import { AppState, useAppSelector } from '@redux/store';

export const useTopicDataById = (id: string | undefined) =>
  useAppSelector(
    ({ topics }: AppState) => (id ? topics.byId[id] : undefined),
    shallowEqual,
  );
